const HostOrigins = ['https://zensum-no-3-0-play.webflow.io', 'https://zensum.no', 'https://www.zensum.no', 'https://dev.zensum.no'];

export default HostOrigins;
